export const repairZero = function (num) {
    return num >= 10 ? num : `0${num}`
}

// 开发环境设置默认 用户信息
export const DEVlocalStorage = function (data) {
    if (process.env.NODE_ENV === 'development') {
        localStorage.setItem('userInfo', JSON.stringify(data))
    }
}

//地址参数字典
export const urlQuery = function () {
    var tmp = {}
    var url = window.location.href
    var str = url.substring(url.lastIndexOf('?') + 1)
    str.replace(/([^?&=\/#]+)=([^?&=\/#]+)/g, function (res, $1, $2) {
        var name = decodeURIComponent($1)
        var val = decodeURIComponent($2)
        tmp[name] = val
    })
    return tmp
}

export const isCurrentEnv = function (current, currentPage, nextPage) {
    // var status = /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|Symbian|Windows Phone|app-peki/i.test(navigator.userAgent) ? 'Mobile' : 'Pc'
    var status = /iPad|Android|webOS|iPhone|iPod|BlackBerry|app-peki/i.test(navigator.userAgent) ? 'Mobile' : 'Pc'
    var url = location.href

    var statusHarmony = /HarmonyOS|OpenHarmony|OpenHamony/i.test(navigator.userAgent)
    if (statusHarmony) {
        status = /Phone|Mobile|Tablet|Handheld/i.test(navigator.userAgent) ? 'Mobile' : 'Pc'
    }

    if (status !== current) {
        window.location.replace(url.replace(`${currentPage}.html`, `${nextPage}.html`))
        return true
    }
    return false
}

export const isPekiApp = function () {
    return navigator.userAgent.indexOf('app-peki') !== -1
}

export const isPekiApplet = function () {
    return window.__wxjs_environment === 'miniprogram'
}

export const timeNumToText = function (num) {
    const m = repairZero(parseInt(num / 60))
    const s = repairZero(num % 60)
    return `${m}:${s}`
}

export const timeNumToHMSText = function (num) {
    const h = repairZero(parseInt(num / 3600))
    const m = repairZero(parseInt(num / 60) % 60)
    const s = repairZero(num % 60)
    return `${h}:${m}:${s}`
}

export const timeToHourMins = function (timeNum) {
    const time = new Date(parseInt(timeNum) * 1000)
    const hours = repairZero(time.getHours())
    const mins = repairZero(time.getMinutes())
    return `${hours}:${mins}`
}

export const replaceUrl = function (msg) {
    msg = String(msg)
    msg = msg.replace(/&amp;/g, '&')
    return msg.replace(/(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-|#)+)/g, (url) => {
        return `<a href='${url}' target='_blank'>${url}</a>`
    })
}

export const timeNumToDHMS = function (num) {
    const days = parseInt(num / 86400)
    let hours = repairZero(parseInt(num / 3600) % 24)
    let minutes = repairZero(parseInt(num / 60) % 60)
    let seconds = repairZero(num % 60)
    return { days, hours, minutes, seconds }
}

// iphoneX 以及X 以上
export const isIphoneX = function () {
    let status = false
    if (/iPhone/i.test(navigator.userAgent)) {
        if (Math.floor(parseFloat(window.screen.height / window.screen.width) * 100) / 100 > 2) {
            status = true
        }
    }
    return status
}

export const isWeixin = function () {
    if (/MicroMessenger/i.test(navigator.userAgent)) {
        return true
    } else {
        return false
    }
}

export const isAlipay = function () {
    if (new RegExp(/alipay/, 'i').test(navigator.userAgent)) {
        return true
    } else {
        return false
    }
}

export const isMobile = function () {
    return /(Android|webOS|iPhone|iPod|tablet|BlackBerry|Mobile)/i.test(navigator.userAgent) ? true : false
}

// Safari ie 不建议观看直播
export const isSafartIe = function () {
    const userAgent = navigator.userAgent
    const isOpera = userAgent.indexOf('Opera') > -1 //判断是否Opera浏览器
    const isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera
    const isSafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') == -1
    if (isSafari || isIE) return true
    return false
}

export const isChrome = function () {
    const userAgent = navigator.userAgent
    return userAgent.indexOf('Chrome') > -1
}

/**
 * path   string 绝对路径
 * params object 地址后的参数
 */
export const redirectUrl = function (path, params) {
    const host = location.host
    let paramsStr = []
    for (const key in params) {
        paramsStr.push(`${key}=${params[key]}`)
    }
    paramsStr = paramsStr.join('&')
    return `https://${host}${path}?${paramsStr}`
}

// 获取东8区的当前时间 方便处理倒计时
export const getCurrentDate = function () {
    const offset = 8
    const localtime = new Date()
    const localmesc = localtime.getTime()
    // 取本地时区与格林尼治所在时区的偏差毫秒数
    const localOffset = localtime.getTimezoneOffset() * 60000
    // 反推得到格林尼治时间
    const utc = localOffset + localmesc
    // 得到指定时区时间
    const calctime = utc + 3600000 * offset
    return new Date(calctime)
}

export const getUserNameTel = function () {
    return localStorage.getItem('userNameTel') ? JSON.parse(localStorage.getItem('userNameTel')) : {}
}

export const setUserNameTel = function (info) {
    localStorage.setItem('userNameTel', JSON.stringify(info))
}

/**
 * 监听 navigator.userAgent 变化
 * @param {Function} callback - userAgent 变化时的回调函数
 * @param {number} interval - 检查间隔（毫秒），默认为 500ms
 * @returns {Function} - 停止监听的函数
 */
export const watchUserAgent = function (callback, interval = 500) {
    let lastUserAgent = navigator.userAgent
    
    const intervalId = setInterval(() => {
        if (navigator.userAgent !== lastUserAgent) {
            const oldUserAgent = lastUserAgent
            lastUserAgent = navigator.userAgent
            callback(oldUserAgent, lastUserAgent)
        }
    }, interval)
    
    // 返回清理函数
    return () => clearInterval(intervalId)
}

export const getLivEmojions = function (msg) {
    const defaultUrl = 'http://static-1.talk-fun.com/open/cooperation/common/emotions/default/'
    const emotionsMap = {
        '[aha]': '001.gif',
        '[amaz]': '009.gif',
        '[bye]': '010.gif',
        '[cool]': '006.gif',
        '[flower]': '005.gif',
        '[good]': '003.gif',
        '[hard]': '002.gif',
        '[love]': '004.gif',
        '[pitiful]': '008.gif',
        '[why]': '007.gif',
    }
    let newMsg = msg
    Object.keys(emotionsMap).forEach((item) => {
        if (newMsg.indexOf(item) !== -1) {
            const list = newMsg.split(item)
            newMsg = list.join(`<img class="emoj-icon" src="${defaultUrl}${emotionsMap[item]}" />`)
        }
    })
    return newMsg
}

// 2020-01-01 00:00:00 转 2020/01/01 00:00:00 兼容 valueOf() NaN
export const dateToTimeStamp = function (date) {
    let newDate = new Date().valueOf()
    if (date) {
        newDate = new Date(date.replace(/-/g, '/')).valueOf()
    }
    return newDate
}

export const randomString = (len) => {
    len = len || 32
    const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyzoOLlgqVvUuI1234567890'
    let str = ''
    for (let index = 0; index < len; index++) {
        str += chars.charAt(Math.floor(Math.random() * chars.length))
    }
    return str
}

export const getDurationText = (time, precision) => {
    let date = parseInt(time)
    if (!date && date !== 0) return '-'
    const h = parseInt(date / 3600)
    const m = parseInt((date % 3600) / 60)
    const s = date % 60

    if (precision === 'minute') {
        return `${repairZero(m + h * 60)}:${repairZero(s)}`
    }
    return `${repairZero(h)}:${repairZero(m)}:${repairZero(s)}`
}

export const getQuestionBlankConfig = (text) => {
    const _l = text ? text.match(/BLANK__\d+/g) || [] : []
    return _l.map((s) => parseInt(s.split('__')[1]) || 100)
}

export const debounce = (fn, delay) => {
    let timer = null
    return function (...args) {
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => {
            fn.apply(this, args)
        }, delay)
    }
}
